export default __webpack_public_path__ + "static/media/provogue.1621608c.png";